import ListApi from "../api/ListApi.js";

export const recommendedLanguages = ["English", "Spanish", "Chinese", "French", "German"],
  states = [
    "Alabama",
    "Alaska",
    "American Samoa",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District of Columbia",
    "Federated States of Micronesia",
    "Florida",
    "Georgia",
    "Guam",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Marshall Islands",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Northern Mariana Islands",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Palau",
    "Pennsylvania",
    "Puerto Rico",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virgin Island",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

export const countries = [
  {name: "Australia", value: "AU"},
  {name: "Austria", value: "AT"},
  {name: "Belgium", value: "BE"},
  {name: "Canada", value: "CA"},
  {name: "Denmark", value: "DK"},
  {name: "Estonia", value: "EE"},
  {name: "Finland", value: "FI"},
  {name: "France", value: "FR"},
  {name: "Germany", value: "DE"},
  {name: "Greece", value: "GR"},
  {name: "Invite only", value: "IO"},
  {name: "Malta", value: "MT"},
  {name: "Mexico", value: "MX"},
  {name: "Netherlands", value: "NL"},
  {name: "New Zealand", value: "NZ"},
  {name: "Norway", value: "NO"},
  {name: "Poland", value: "PL"},
  {name: "Sweden", value: "SE"},
  {name: "Switzerland", value: "CH"},
  {name: "United Arab Emirates", value: "AE"},
  {name: "United Kingdom", value: "GB"},
  {name: "United States", value: "US"},
];

export const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const preferences = ["Preferred", "Required"];
export const employmentTypes = [
  "Full Time",
  "Part Time",
  "Contract",
  "Internship",
  "Temporary",
  "Per Diem",
];
export const educationLevels = [
  "High School",
  "Some College",
  "Associate's Degree",
  "Bachelor's Degree",
  "Master's Degree",
  "Doctorate's Degree",
];

export const locationOptions = [
  {
    name: "On-Site Only",
    value: "On-Site Only",
  },
  {
    name: "Hybrid Remote",
    value: "Remote or On-Site",
  },
  {
    name: "Remote Only",
    value: "Remote Only",
  }
];

export const timezones = [
  { name: "Eastern Time (EST/EDT)", value: "America/New_York" },
  { name: "Central Time (CST/CDT)", value: "America/Chicago" },
  { name: "Mountain Time (MST/MDT)", value: "America/Denver" },
  { name: "Mountain Time (Arizona)", value: "America/Phoenix" },
  { name: "Pacific Time (PST/PDT)", value: "America/Los_Angeles" },
  { name: "Alaska Time (AKT)", value: "America/Anchorage" },
  { name: "Hawaii-Aleutian Time (HAT)", value: "Pacific/Honolulu" },
  { name: "Atlantic Time (AT)", value: "America/Halifax" },
  { name: "Newfoundland Time (NT)", value: "America/St_Johns" },
  { name: "Saskatchewan Time", value: "America/Regina" },
  { name: "Pacific Time (Vancouver)", value: "America/Vancouver" },
  { name: "Eastern Time (Toronto)", value: "America/Toronto" },
  { name: "Central Time (Winnipeg)", value: "America/Winnipeg" },
  { name: "Mountain Time (Edmonton)", value: "America/Edmonton" },
  { name: "Pacific Time (Whitehorse)", value: "America/Whitehorse" },
  { name: "Atlantic Time (Bermuda)", value: "Atlantic/Bermuda" },
  { name: "UTC", value: "UTC" },
];

export const languages = async (params) => {
  let listApi = new ListApi("languages");
  return await listApi.index(params);
};

export const industries = async (params) => {
  let listApi = new ListApi("industries");
  return await listApi.index(params);
};

export const jobs = async (params) => {
  let listApi = new ListApi("job-titles");
  return await listApi.index(params);
};

export const usaCities = async (params) => {
  let listApi = new ListApi("usa-cities");
  return await listApi.index(params);
};

export const benefits = async (params) => {
  let listApi = new ListApi("benefits");
  return await listApi.index(params);
};
